// Dictionnaire français de l'interface. Clés en anglais, structurées par domaine.
// T05 livre les sections du shell et de l'auth, plus `errors` et `validation` complètes ;
// chaque écran suivant ajoute sa section (`opportunities`, `scans`, …).
export const fr = {
  app: {
    name: 'Elvn Radar',
    tagline: 'Product intelligence',
  },
  nav: {
    dashboard: 'Tableau de bord',
    seeds: 'Seeds',
    scans: 'Scans',
    toTriage: 'À trier',
    review: 'Revue d’équipe',
    experiments: 'Expériences',
    calibration: 'Calibration',
    clusters: 'Clusters',
    settings: 'Paramètres',
    groups: {
      path: 'Parcours',
      learn: 'Apprendre',
      explore: 'Explorer',
    },
    step: 'Étape {n}',
    stepTooltip: '{n} · {label}',
    counts: {
      seeds_one: '{count} active',
      seeds_other: '{count} actives',
      scans_one: '{count} en cours',
      scans_other: '{count} en cours',
      toTriage_one: '{count} à traiter',
      toTriage_other: '{count} à traiter',
      shortlisted_one: '{count} en shortlist',
      shortlisted_other: '{count} en shortlist',
      experimentsRunning_one: '{count} en cours',
      experimentsRunning_other: '{count} en cours',
    },
    main: 'Navigation principale',
    skipToContent: 'Aller au contenu',
    toggleSidebar: 'Replier ou déplier la navigation',
  },
  common: {
    save: 'Enregistrer',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    delete: 'Supprimer',
    search: 'Rechercher',
    loading: 'Chargement…',
    empty: 'Aucun élément',
    retry: 'Réessayer',
    rationale: 'Justification',
    required: 'Champ requis',
    details: 'Détails',
    close: 'Fermer',
    more: 'Plus',
    comingSoon: 'Bientôt disponible',
    comingSoonDescription: 'Cet écran arrive dans une prochaine version.',
    items_one: '{count} élément',
    items_other: '{count} éléments',
    all: 'Tous',
    yes: 'Oui',
    no: 'Non',
    edit: 'Modifier',
    create: 'Créer',
    clearFilters: 'Effacer les filtres',
    discardTitle: 'Abandonner les modifications ?',
    discardDescription: 'Les modifications non enregistrées seront perdues.',
    discard: 'Abandonner',
    keepEditing: 'Continuer la saisie',
    optional: 'optionnel',
    copy: 'Copier',
    copied: 'Copié',
    none: 'Aucun',
    inProgress: 'en cours',
  },
  table: {
    selected_one: '{count} sélectionnée',
    selected_other: '{count} sélectionnées',
    clearSelection: 'Annuler la sélection',
    range: '{from}–{to} sur {total}',
    pageSize: 'Lignes par page',
    previous: 'Page précédente',
    next: 'Page suivante',
    pageOf: '{page} / {pages}',
    selectAll: 'Sélectionner toutes les lignes de la page',
    selectRow: 'Sélectionner la ligne {label}',
    sortBy: 'Trier par {column}',
    rowActions: 'Actions de la ligne',
    loading: 'Chargement des lignes',
    bulkActions: 'Actions groupées',
  },
  filters: {
    clear: 'Effacer',
    min: 'Min',
    max: 'Max',
    all: 'Tous',
    presets: 'Vues rapides',
    options: 'Options du filtre {label}',
    addValue: 'Ajouter une valeur à {label}',
    add: 'Ajouter',
  },
  seeds: {
    title: 'Seeds',
    count: 'Seeds · {count}',
    new: 'Nouveau seed',
    import: 'Importer un CSV',
    search: 'Rechercher un seed…',
    type: {
      keywords: 'Mots-clés',
      url: 'URL',
      site: 'Site',
      keywords_url: 'Mots-clés + URL',
    },
    columns: {
      label: 'Libellé',
      type: 'Type',
      content: 'Contenu',
      category: 'Catégorie',
      tags: 'Tags',
      active: 'Actif',
      lastUsedAt: 'Dernier usage',
      createdAt: 'Créé',
    },
    filters: {
      type: 'Type',
      category: 'Catégorie',
      active: 'Actif',
    },
    empty: {
      title: 'Créez votre premier seed',
      description:
        'Un seed est un point de départ pour un scan : des mots-clés, une URL ou un site, par marché.',
      filteredTitle: 'Aucun seed ne correspond',
      filteredDescription: 'Modifiez ou effacez les filtres pour élargir la recherche.',
    },
    form: {
      createTitle: 'Nouveau seed',
      editTitle: 'Modifier le seed',
      createDescription: 'Le seed sera disponible pour les scans du marché choisi.',
      editDescription: 'Le marché d’un seed ne peut pas être changé.',
      market: 'Marché',
      type: 'Type',
      label: 'Libellé',
      keywords: 'Mots-clés',
      keywordsHint: 'Un mot-clé par ligne, {max} au maximum.',
      keywordsCount: '{count} / {max}',
      duplicates_one: '{count} doublon ignoré',
      duplicates_other: '{count} doublons ignorés',
      longKeywords_one:
        '{count} mot-clé est une phrase : les expressions longues rapportent peu d’idées. Préférez 2 à 4 mots, comme on les tape dans Google.',
      longKeywords_other:
        '{count} mots-clés sont des phrases : les expressions longues rapportent peu d’idées. Préférez 2 à 4 mots, comme on les tape dans Google.',
      url: 'URL',
      urlPlaceholder: 'https://',
      category: 'Catégorie',
      categoryHint: 'Regroupe les seeds dans les filtres et le formulaire de scan.',
      tags: 'Tags',
      tagsHint: 'Séparés par des virgules.',
      removeTag: 'Retirer le tag {tag}',
      notes: 'Notes',
      active: 'Actif',
      activeHint: 'Un seed inactif n’est pas proposé dans les nouveaux scans.',
    },
    toggleActive: 'Activer le seed {label}',
    saved: 'Seed enregistré',
    created: 'Seed créé',
    deleted: 'Seed supprimé',
    delete: {
      title: 'Supprimer le seed « {label} » ?',
      description:
        'Cette action est définitive. Les mots-clés déjà collectés par ce seed restent en base.',
      confirm: 'Supprimer',
    },
    importDialog: {
      title: 'Importer un CSV',
      description:
        'Colonnes attendues : label, keywords (séparés par |), category. Séparateur « ; » ou « , », champs entre guillemets acceptés.',
      file: 'Fichier CSV',
      preview: 'Aperçu',
      previewCount_one: '{count} ligne lue',
      previewCount_other: '{count} lignes lues',
      line: 'Ligne',
      status: 'Statut',
      ok: 'OK',
      submit_one: 'Importer {count} ligne valide',
      submit_other: 'Importer {count} lignes valides',
      result: '{created} seeds importés, {updated} mis à jour',
      serverErrors_one: '{count} ligne refusée par le serveur',
      serverErrors_other: '{count} lignes refusées par le serveur',
      rowError: 'Ligne {line} : {message}',
      missingLabel: 'Libellé manquant',
      missingHeaders: 'En-têtes attendus : label, keywords (category optionnel).',
      empty: 'Aucune ligne de données dans ce fichier.',
      unreadable: 'Impossible de lire ce fichier.',
    },
    assist: {
      openAssistant: 'Seed avec l’IA',
      analyze: 'Analyser le site',
      priced: '{label} · ≈ {cost}',
      analyzing: 'Lecture du site…',
      suggestionsTitle: 'Suggestions',
      summary: 'Résumé',
      suggestedLabel: 'Libellé proposé',
      suggestedCategory: 'Catégorie proposée',
      suggestedTags: 'Tags proposés',
      suggestedNotes: 'Notes proposées',
      keywordsSite: 'Vu sur le site',
      keywordsAdjacent: 'Besoins voisins',
      addSelection_one: 'Ajouter la sélection ({count})',
      addSelection_other: 'Ajouter la sélection ({count})',
      replace: 'Remplacer',
      typeSwitchHint: 'Le type passera en « Mots-clés + URL » : l’URL est conservée.',
      truncated_one: '{count} mot-clé non ajouté : un seed compte {max} mots-clés au plus.',
      truncated_other: '{count} mots-clés non ajoutés : un seed compte {max} mots-clés au plus.',
      added_one:
        '{count} mot-clé ajouté au formulaire. Rien n’est enregistré avant « Enregistrer ».',
      added_other:
        '{count} mots-clés ajoutés au formulaire. Rien n’est enregistré avant « Enregistrer ».',
      addedNone: 'Aucun nouveau mot-clé : ils étaient déjà dans le formulaire.',
      sourcePages_one: '{count} page lue',
      sourcePages_other: '{count} pages lues',
      sourceChars: '{chars} caractères',
      sourceTruncated: 'texte tronqué',
      costActual: 'coût {cost}',
      costVolumes: 'dont volumes {cost}',
      dismiss: 'Masquer les suggestions',
      volumeWithDemand_one: '{count} terme avec demande',
      volumeWithDemand_other: '{count} termes avec demande',
      volumeBelow_one: '{count} sous le seuil de {min}',
      volumeBelow_other: '{count} sous le seuil de {min}',
      volumeWithout_one: '{count} sans',
      volumeWithout_other: '{count} sans',
      volumeZeroHint: '0 recherche par mois : ne rapportera aucune idée',
      volumeUnknownHint: 'Volume inconnu : le fournisseur n’a rien renvoyé pour ce terme',
      checkVolumes: 'Vérifier les volumes',
      checkingVolumes: 'Vérification des volumes…',
      volumesNextTurn: 'L’assistant remplacera les termes sans recherche au prochain échange.',
      dialog: {
        title: 'Seed avec l’IA',
        description:
          'Décrivez ce que vous construisez ; l’assistant met le brouillon à jour à chaque échange.',
        welcome:
          'Bonjour. Décrivez ce que vous construisez ou explorez, pour qui, et le marché visé : je transformerai cela en un brouillon de seed (libellé, mots-clés, catégorie) que vous pourrez ajuster avant de l’appliquer.',
        conversation: 'Discussion',
        you: 'Vous',
        assistant: 'Assistant',
        input: 'Votre message',
        placeholder:
          'Ex. : un outil qui convertit des relevés bancaires PDF en Excel, pour des experts-comptables en France',
        send: 'Envoyer',
        thinking: 'L’assistant réfléchit…',
        costHint: '≈ {cost} par message',
        enterHint: 'Entrée pour envoyer, Maj+Entrée pour un saut de ligne.',
        draftTitle: 'Brouillon de seed',
        draftHint:
          'Mis à jour à chaque échange ; les champs modifiés au dernier tour sont surlignés.',
        ready: 'L’assistant considère le brouillon prêt.',
        changed: 'modifié au dernier tour',
        apply: 'Appliquer',
        applyHint: 'Remplit le volet de seed. Rien n’est enregistré avant « Enregistrer ».',
        closeTitle: 'Fermer la discussion ?',
        closeDescription:
          'La conversation n’est pas conservée. Le brouillon affiché sera perdu s’il n’est pas appliqué.',
        closeConfirm: 'Fermer',
      },
    },
  },
  scans: {
    title: 'Scans',
    count: 'Scans · {count}',
    new: 'Nouveau scan',
    status: {
      queued: 'En attente',
      running: 'En cours',
      paused_budget: 'En pause (budget)',
      completed: 'Terminé',
      failed: 'En échec',
      cancelled: 'Annulé',
    },
    phase: {
      ingest: 'Ingestion',
      variants: 'Variantes',
      embed: 'Embeddings',
      cluster: 'Clustering',
      metrics: 'Métriques',
      prefilter: 'Préfiltre',
      triage: 'Triage',
      serp: 'SERPs',
      supply: 'Offre',
      deep: 'Analyse',
      score: 'Score',
      finalize: 'Finalisation',
    },
    counts: {
      ideas_fetched: 'Idées récupérées',
      keywords_new: 'Mots-clés nouveaux',
      keywords_updated: 'Mots-clés mis à jour',
      variants_grouped: 'Variantes groupées',
      embedded: 'Mots-clés embarqués',
      clusters_new: 'Clusters nouveaux',
      clusters_updated: 'Clusters mis à jour',
      candidates: 'Candidats',
      triaged: 'Clusters triés',
      serps_requested: 'SERPs demandées',
      serps_ready: 'SERPs prêtes',
      deep_analyses: 'Analyses profondes',
      opportunities_new: 'Opportunités nouvelles',
      opportunities_rescored: 'Opportunités rescorées',
    },
    phaseCounts: {
      ideas: '{count} idées',
      variants: '{count} variantes',
      embedded: '{count} embarqués',
      clustersNew: '{count} nouveaux',
      candidates: '{count} candidats',
      triaged: '{count} triés',
      serps: '{ready} / {requested}',
      analyses: '{count} analyses',
      opportunities: '{count} opportunités',
    },
    progress: {
      done: 'Terminée',
      current: 'En cours',
      upcoming: 'À venir',
      failed: 'En échec',
      paused: 'En pause',
      stopped: 'Interrompue',
    },
    seedStatus: {
      pending: 'En attente',
      done: 'Terminé',
      failed: 'En échec',
      skipped: 'Ignoré',
    },
    columns: {
      label: 'Libellé',
      market: 'Marché',
      status: 'Statut',
      phase: 'Phase',
      seeds: 'Seeds',
      keywordsNew: 'Mots-clés nouveaux',
      opportunitiesNew: 'Opportunités nouvelles',
      cost: 'Coût ($)',
      createdBy: 'Créé par',
      startedAt: 'Démarré',
      duration: 'Durée',
    },
    filters: {
      status: 'Statut',
    },
    empty: {
      title: 'Aucun scan',
      description: 'Lancez le premier scan pour alimenter le radar.',
      filteredTitle: 'Aucun scan ne correspond',
      filteredDescription: 'Modifiez ou effacez les filtres pour élargir la recherche.',
    },
    form: {
      title: 'Nouveau scan',
      description: 'Choisissez des seeds, ajustez les plafonds et estimez le coût avant de lancer.',
      market: 'Marché',
      marketHint: 'Le marché se change depuis le sélecteur en haut de page.',
      noMarket: 'Aucun marché disponible.',
      label: 'Libellé',
      defaultLabel: 'Scan {market} {date}',
      seeds: 'Seeds',
      seedsSearch: 'Rechercher un seed…',
      seedsCategory: 'Catégorie',
      seedsUncategorized: 'Sans catégorie',
      selectAllInCategory: 'Tout sélectionner dans la catégorie',
      selectAllVisible: 'Tout sélectionner',
      clearSelection: 'Tout désélectionner',
      selected_one: '{count} seed sélectionné · ~{keywords} mots-clés seeds',
      selected_other: '{count} seeds sélectionnés · ~{keywords} mots-clés seeds',
      seedsColumns: {
        label: 'Libellé',
        type: 'Type',
        category: 'Catégorie',
        keywords: 'Mots-clés',
      },
      noSeeds: 'Aucun seed actif pour ce marché',
      noSeedsDescription: 'Créez des seeds pour pouvoir lancer un scan.',
      noSeedsFiltered: 'Aucun seed ne correspond à la recherche',
      createSeeds: 'Créer des seeds',
      caps: 'Plafonds',
      capTriage: 'Clusters au triage',
      capTriageHint: 'Nombre maximal de clusters envoyés au triage LLM.',
      capSerpClusters: 'Clusters avec SERPs',
      capSerpClustersHint: 'Nombre maximal de clusters dont les SERPs sont achetées.',
      capDeep: 'Analyses profondes',
      capDeepHint: 'Nombre maximal d’analyses profondes LLM.',
      capCost: 'Coût maximal du scan ($)',
      capCostHint:
        'Au-delà, le scan se met en pause en attendant l’approbation d’un administrateur.',
      advanced: 'Avancé',
      thetaAssign: 'Seuil d’affectation θ',
      thetaAssignHint: 'Similarité minimale pour rattacher un mot-clé à un cluster (0,70 à 0,95).',
      serpPerCluster: 'SERPs par cluster',
      serpPerClusterHint: 'Mots-clés représentatifs dont la SERP est achetée, par cluster (1 à 3).',
      includeAdult: 'Inclure les mots-clés adultes',
      includeAdultHint: 'Toujours exclu en V0.',
      estimate: 'Estimer le coût',
      estimateTitle: 'Estimation',
      estimateHint: 'Estimation indicative ; le coût réel est mesuré pendant le scan.',
      estimateStale: 'Sélection ou plafonds modifiés : l’estimation est en cours de mise à jour.',
      estimateEmpty: 'Sélectionnez au moins un seed puis estimez le coût du scan.',
      total: 'Total estimé',
      monthlyRemaining: 'Reste du mois : {amount}',
      scanCap: 'Plafond du scan : {amount}',
      pauseWarning:
        'Le scan se mettra en pause à la phase {phase} ; un administrateur devra l’approuver.',
      submit: 'Lancer le scan',
      launched: 'Scan lancé',
      viewScan: 'Voir le scan',
    },
    detail: {
      breadcrumb: 'Scans',
      updatedAgo: 'Mise à jour il y a {seconds} s',
      instance: 'Instance : {status}',
      instanceError: 'Erreur d’instance : {error}',
      instanceUnknown: 'Instance introuvable',
      duration: 'Durée',
      cost: 'Coût',
      costOf: '{spent} / {cap}',
      estimated: 'Estimé : {amount}',
      createdBy: 'Créé par {name}',
      actions: 'Actions',
      cancel: 'Annuler',
      cancelTitle: 'Annuler le scan ?',
      cancelDescription:
        'Le coût déjà engagé n’est pas remboursé. Les données ingérées restent en base : relancer un scan ne les duplique pas.',
      cancelConfirm: 'Annuler le scan',
      cancelled: 'Scan annulé',
      retry: 'Relancer',
      retried: 'Scan relancé',
      approve: 'Approuver le budget',
      approveTitle: 'Approuver le budget du scan ?',
      approveDescription:
        'Le scan reprendra à la phase {phase}. Coût estimé de la phase : {estimate}. Coût du scan : {spent} / {cap}. Reste du mois : {remaining}.',
      approveConfirm: 'Approuver',
      approved: 'Budget approuvé, le scan reprend',
      banner: {
        pausedMember: 'En attente d’approbation par un administrateur (coût estimé {amount}).',
        pausedAdmin:
          'Scan en pause : le coût estimé ({amount}) dépasse un plafond. Approuvez le budget pour continuer.',
        failed: 'Scan en échec : {error}',
        failedUnknown: 'Scan en échec.',
        cancelled: 'Scan annulé.',
        budgetTimeout: 'Scan annulé : budget non approuvé sous 7 jours.',
      },
      phases: 'Phases',
      counters: 'Compteurs',
      seeds: 'Seeds',
      seedsColumns: {
        label: 'Libellé',
        status: 'Statut',
        ideas: 'Idées',
        pages: 'Pages',
        error: 'Erreur',
      },
      log: 'Journal',
      logLevel: 'Niveau du journal',
      logCount_one: '{count} événement',
      logCount_other: '{count} événements',
      follow: 'Suivre',
      copyLog: 'Copier le journal',
      logCopied: 'Journal copié',
      logCopyFailed: 'Impossible de copier le journal',
      logEmpty: 'Aucun événement pour ce niveau.',
      results: 'Résultats',
      resultsNew: 'Nouvelles opportunités',
      resultsRescored: 'Opportunités rescorées',
      resultsMerges: 'Suggestions de fusion',
      noOpportunities: 'Aucune opportunité',
      noRescored: 'Rien à rescorer : ce scan n’a touché aucune opportunité existante.',
      noMerges:
        'Aucune suggestion : il faut deux clusters avec SERPs partageant au moins {min} URL organiques du top 10.',
      resultsColumns: {
        title: 'Titre',
        score: 'Score',
        confidence: 'Confiance',
        before: 'Avant',
        after: 'Après',
        change: 'Évolution',
        clusterA: 'Cluster A',
        clusterB: 'Cluster B',
        overlap: 'Recouvrement',
      },
      scoreChange: '{before} → {after}',
    },
    funnel: {
      title: 'Lecture du résultat',
      description:
        'Ce que le scan a trouvé, étape par étape, et pourquoi des clusters sont sortis en route.',
      stepsLabel: 'Étapes du scan',
      steps: {
        ideas: 'Idées',
        keywordsNew: 'Mots-clés nouveaux',
        clusters: 'Clusters',
        candidates: 'Candidats',
        passed: 'Triés ≥ {min}',
        serps: 'SERPs',
        analyses: 'Analyses',
        opportunities: 'Opportunités',
      },
      serpsValue: '{ready} / {requested}',
      drops: 'Pourquoi des clusters sortent',
      noDrops: 'Aucune chute : chaque étape a abouti jusqu’aux opportunités.',
      noReason: 'sans motif enregistré',
      moreReasons_one: '{count} autre motif',
      moreReasons_other: '{count} autres motifs',
      prefilterDrop_one: '{count} cluster écarté au préfiltre : {reasons}.',
      prefilterDrop_other: '{count} clusters écartés au préfiltre : {reasons}.',
      gateReason: '{count} {label} ({gate})',
      gates: {
        exclusion: 'terme d’exclusion',
        low_demand: 'volume insuffisant',
        informational: 'informationnel',
        news_local: 'actualité ou local',
        untestable: 'non testable',
        triage: 'écarté au triage',
        brand: 'marque dominante',
      },
      gateCodes: {
        exclusion: 'G1',
        low_demand: 'G2',
        informational: 'G3',
        news_local: 'G4',
        untestable: 'G5',
        triage: 'G6',
        brand: 'G7',
      },
      triageDrop_one:
        '{count} cluster trié sans passer le triage ({below} sous le seuil de {min}) : {reasons}.',
      triageDrop_other:
        '{count} clusters triés sans passer le triage ({below} sous le seuil de {min}) : {reasons}.',
      triageReason: '{label} ({count})',
      triageReasons: {
        not_a_job: 'requêtes informationnelles, sans tâche',
        no_digital_product: 'pas de produit numérique possible',
        product_type_none: 'aucun type de produit adapté',
        exclusion: 'catégorie exclue ({category})',
        is_brand_dominated: 'dominé par une marque',
      },
      triageFailed_one:
        '{count} appel de triage sans résultat ({failed} en échec, {invalid} invalide) : relancez un scan pour le rejouer.',
      triageFailed_other:
        '{count} appels de triage sans résultat ({failed} en échec, {invalid} invalides) : relancez un scan pour les rejouer.',
      serpsFailed_one:
        '{count} SERP non reçue sur {requested} : le cluster concerné manque de preuves d’offre.',
      serpsFailed_other:
        '{count} SERPs non reçues sur {requested} : les clusters concernés manquent de preuves d’offre.',
      serpsCap:
        '{clusters} clusters avec SERPs sur {passed} éligibles : plafond du scan atteint ({cap}). Relevez « Clusters avec SERPs » pour couvrir le reste.',
      deepDrop_one: '{count} analyse non aboutie ({invalid} invalide, {failed} en échec).',
      deepDrop_other: '{count} analyses non abouties ({invalid} invalides, {failed} en échec).',
      deepCap:
        '{analyses} analyses sur {clusters} clusters enrichis : plafond du scan atteint ({cap}). Relevez « Analyses profondes » pour analyser le reste.',
      scoringDrop_one: '{count} cluster écarté au scoring : {reasons}.',
      scoringDrop_other: '{count} clusters écartés au scoring : {reasons}.',
      scoringReasons: {
        below_threshold: 'score sous le minimum de {min}',
        no_analysis: 'sans analyse profonde',
        no_metrics: 'sans métriques',
        not_candidate: 'plus candidat',
        terminal_status: 'opportunité clôturée',
      },
      seeds: 'Par seed',
      seedColumns: {
        label: 'Libellé',
        type: 'Type',
        ideas: 'Idées',
        keywordsNew: 'Mots-clés nouveaux',
      },
      hints: {
        few_ideas_site:
          '{count} idées seulement pour un site : Google associe peu de requêtes à ce domaine. Analysez le site pour en tirer des mots-clés.',
        few_ideas_long_keywords:
          '{count} idées seulement : des mots-clés trop longs ({words} mots en moyenne), Keyword Planner ne dérive rien autour d’une phrase. Reformulez en expressions de 2 à 4 mots.',
        few_ideas: '{count} idées seulement : sujet étroit. Ajoutez des termes plus génériques.',
      },
      openSeed: 'Ouvrir la seed « {label} »',
      emptyResults: {
        prefilter_one: 'Aucune opportunité : le seul cluster a été écarté au préfiltre ({reason}).',
        prefilter_other:
          'Aucune opportunité : les {count} clusters ont été écartés au préfiltre ({reason}).',
        triage_one:
          'Aucune opportunité : le seul cluster trié est resté sous le seuil de {min} ({reason}).',
        triage_other:
          'Aucune opportunité : les {count} clusters triés sont restés sous le seuil de {min} ({reason}).',
        deep: 'Aucune opportunité : aucune analyse profonde n’a abouti.',
        scoring_one:
          'Aucune opportunité : le cluster analysé n’a pas atteint le score minimal de {min}.',
        scoring_other:
          'Aucune opportunité : {count} clusters analysés n’ont pas atteint le score minimal de {min}.',
      },
      seeReading: 'Voir la lecture du résultat',
    },
  },
  budget: {
    remaining: 'Reste du mois',
    scanCap: 'Plafond du scan',
    warn: 'Le coût approche du plafond.',
    over: 'Le coût dépasse le plafond.',
    of: '{spent} / {cap}',
  },
  metric: {
    hint: 'Définition de {label}',
  },
  costMeter: {
    line: 'Poste',
    units: 'Unités',
    cost: 'Coût',
    total: 'Total',
  },
  timeline: {
    level: {
      info: 'Info',
      warn: 'Avertissement',
      error: 'Erreur',
    },
    data: 'Détails',
    loadMore: 'Charger plus',
    system: 'Système',
    empty: 'Aucun événement',
    list: 'Journal des événements',
  },
  opportunities: {
    title: 'Opportunités',
    status: {
      new: 'Nouvelle',
      triaged: 'Triée',
      shortlisted: 'Shortlistée',
      experiment_planned: 'Expérience planifiée',
      experiment_running: 'Expérience en cours',
      validated: 'Validée',
      invalidated: 'Invalidée',
      inconclusive: 'Non concluante',
      building: 'En construction',
      launched: 'Lancée',
      rejected: 'Rejetée',
      parked: 'Mise de côté',
      merged: 'Fusionnée',
      archived: 'Archivée',
    },
    axes: {
      A: 'Demande et trajectoire',
      B: 'Intention et intensité',
      C: 'Valeur commerciale',
      D: 'Faiblesse de l’offre',
      E: 'Faisabilité',
      F: 'Distribution',
      G: 'Risques',
    },
    count: 'Opportunités · {count}',
    search: 'Rechercher une opportunité…',
    breadcrumb: 'Opportunités',
    blockingUnknowns_one: '{count} inconnue bloquante',
    blockingUnknowns_other: '{count} inconnues bloquantes',
    confidence: {
      low: 'Confiance faible',
      medium: 'Confiance moyenne',
      high: 'Confiance élevée',
      aria: 'Confiance {label}, {value}',
      label: 'Confiance',
    },
    score: {
      none: 'Score indisponible',
      aria: 'Score {value} sur 100',
      ariaReviewed: 'Score {value} sur 100, revu {reviewed}',
      tooltipReviewed: 'Score système {value} · score revu {reviewed}',
      tier1: 'Palier 1 · moins de 40',
      tier2: 'Palier 2 · 40 à 54',
      tier3: 'Palier 3 · 55 à 69',
      tier4: 'Palier 4 · 70 et plus',
      riskyHypothesis: 'Hypothèse à investiguer : preuves insuffisantes.',
      system: 'Score système',
      reviewed: 'Score revu',
    },
    productType: {
      web_app: 'Web app',
      browser_extension: 'Extension',
      api: 'API',
      mobile_app: 'Mobile',
      none: 'Aucun',
    },
    columns: {
      title: 'Job',
      status: 'Statut',
      score: 'Score',
      scoreReviewed: 'Score (revu)',
      scoreSort: 'Trier par score',
      sortSystem: 'Trier par score système',
      sortReviewed: 'Trier par score revu',
      confidence: 'Confiance',
      volume: 'Volume',
      bidHigh: 'Enchère ($)',
      productType: 'Type',
      owner: 'Owner',
      updatedAt: 'Mis à jour',
    },
    filters: {
      status: 'Statut',
      score: 'Score',
      minConfidence: 'Confiance min',
      productType: 'Type',
      owner: 'Owner',
      ownerMe: 'Moi',
      ownerNone: 'Non assignée',
      tags: 'Tags',
      updatedSince: 'Modifiées depuis',
    },
    presets: {
      toTriage: 'À trier',
      shortlist: 'Shortlist',
      validating: 'En validation',
      done: 'Terminées',
    },
    empty: {
      title: 'Aucune opportunité pour l’instant',
      description: 'Les opportunités naissent d’un scan, ou d’une création manuelle.',
      action: 'Lancer un scan',
      filteredTitle: 'Aucune opportunité ne correspond à ces filtres',
      filteredDescription: 'Élargissez la recherche ou effacez les filtres.',
    },
    reasons: {
      not_a_job: 'Faux positif : pas un job',
      informational: 'Recherche informationnelle',
      brand: 'Requête de marque',
      excluded_category: 'Catégorie exclue',
      too_small: 'Trop petit',
      well_served: 'Déjà bien couvert',
      not_buildable: 'Non construisible',
      duplicate: 'Doublon',
      other: 'Autre',
    },
    transitions: {
      title: 'Changer le statut',
      description: '{label} · statut actuel : {status}',
      targets: 'Nouveau statut',
      reason: 'Raison',
      reasonPlaceholder: 'Choisissez une raison',
      parkUntil: 'Date de rappel',
      launchedAt: 'Date de lancement',
      noTarget: 'Aucune transition n’est autorisée depuis ce statut.',
      applied_one: 'Appliqué à {count} opportunité.',
      applied_other: 'Appliqué à {count} opportunités.',
      ignored:
        '{processed} opportunités seront traitées, {ignored} ignorée(s) (statut {statuses}).',
      blockingUnknowns:
        '{count} inconnue(s) bloquante(s) non résolue(s) : une justification est obligatoire.',
      needsPlannedExperiment: 'Une expérience planifiée est requise ; le serveur refusera sinon.',
      needsRunningExperiment: 'L’expérience doit être en cours ; le serveur refusera sinon.',
      needsVerdict: 'Le verdict se rend depuis l’expérience ; le serveur refusera sinon.',
      interpretation: 'Le job et le segment doivent être renseignés.',
      submit: {
        new: 'Rouvrir',
        triaged: 'Trier',
        shortlisted: 'Shortlister',
        experiment_planned: 'Planifier l’expérience',
        experiment_running: 'Démarrer l’expérience',
        validated: 'Valider',
        invalidated: 'Invalider',
        inconclusive: 'Marquer non concluante',
        building: 'Passer en construction',
        launched: 'Marquer lancée',
        rejected: 'Rejeter',
        parked: 'Mettre de côté',
        merged: 'Fusionner',
        archived: 'Archiver',
      },
      done: {
        new: 'Rouverte',
        triaged: 'Triée',
        shortlisted: 'Shortlistée',
        experiment_planned: 'Expérience planifiée',
        experiment_running: 'Expérience en cours',
        validated: 'Validée',
        invalidated: 'Invalidée',
        inconclusive: 'Non concluante',
        building: 'En construction',
        launched: 'Lancée',
        rejected: 'Rejetée',
        parked: 'Mise de côté',
        merged: 'Fusionnée',
        archived: 'Archivée',
      },
    },
    bulk: {
      reject: 'Rejeter',
      shortlist: 'Shortlister',
      summary: '{count} {done}, {failed} refusée(s) : {reason}',
      summaryOk: '{count} {done}',
      assigned: '{count} opportunité(s) assignée(s) à {owner}',
      assignDescription: 'L’owner sera appliqué à {count} opportunité(s).',
      assignSearch: 'Rechercher un utilisateur…',
    },
    create: {
      action: 'Nouvelle opportunité',
      title: 'Créer une opportunité',
      description: 'Une opportunité manuelle, hors pipeline.',
      note: 'Une opportunité manuelle n’a ni cluster ni score système tant qu’elle n’est pas rattachée.',
      submit: 'Créer',
    },
    fields: {
      market: 'Marché',
      title: 'Titre',
      canonicalJob: 'Job canonique',
      targetSegment: 'Segment cible',
      productType: 'Type de produit',
      secondarySegments: 'Segments secondaires',
      context: 'Contexte',
      currentOffer: 'Offre actuelle',
      valueProposition: 'Proposition de valeur',
      wedge: 'Angle d’entrée',
      keyFeatures: 'Fonctionnalités clés',
      dependencies: 'Dépendances',
      pricingModel: 'Modèle de prix',
      pricePoint: 'Prix envisagé',
      pricingRationale: 'Justification du prix',
      adsViability: 'Viabilité publicitaire',
      seoViability: 'Viabilité SEO',
      otherChannels: 'Autres canaux',
      recommendedNextStep: 'Prochaine étape recommandée',
      tags: 'Tags',
      manualRank: 'Rang',
      status: 'Statut',
      owner: 'Owner',
    },
    actions: {
      open: 'Ouvrir',
      changeStatus: 'Changer le statut',
      override: 'Corriger un axe',
      comment: 'Commenter',
      assign: 'Assigner',
      merge: 'Fusionner',
      refreshSerp: 'Rafraîchir les SERPs',
      reanalyze: 'Ré-analyser',
      prepareValidation: 'Préparer une validation',
      openCluster: 'Ouvrir le cluster',
    },
    breakdown: {
      title: 'Décomposition du score',
      axisValue: 'Valeur système : {value} / 10',
      penalty: 'Pénalité : {value} / 10',
      override: 'Corriger l’axe {axis}',
      overridden: 'Axe corrigé par un override actif.',
      systemScore: 'Score système {value} · aperçu recalculé côté client à l’override.',
    },
    evidence: {
      title: 'Preuves',
      empty: 'Aucune preuve enregistrée.',
      unknownRef: 'Référence introuvable',
    },
    unknowns: {
      title: 'Inconnues',
      empty: 'Aucune inconnue.',
      blocking: 'Bloquante',
      resolve: 'Résoudre',
      resolution: 'Résolution',
      markResolved: 'Marquer résolue',
      resolvedCount_one: '{count} résolue',
      resolvedCount_other: '{count} résolues',
    },
    risks: {
      title: 'Risques',
      empty: 'Aucun risque identifié.',
      severity: {
        low: 'faible',
        medium: 'moyen',
        high: 'élevé',
      },
    },
    severity: {
      low: 'Faible',
      medium: 'Moyenne',
      high: 'Élevée',
    },
    pricingModel: {
      subscription: 'Abonnement',
      usage: 'À l’usage',
      one_time: 'Paiement unique',
      freemium: 'Freemium',
      unknown: 'Inconnu',
    },
    subScores: {
      demand_strength: 'Force de la demande',
      job_intensity: 'Intensité du job',
      commercial_intent: 'Intention commerciale',
      supply_quality: 'Qualité de l’offre',
      buildability: 'Constructibilité',
      monetization_potential: 'Potentiel de monétisation',
      distribution_access: 'Accès à la distribution',
      risk: 'Risque',
    },
    refs: {
      keyword: 'mot-clé #{id}',
      serp: '{domain} · #{rank}',
    },
    override: {
      title: 'Corriger l’axe {axis}',
      description: 'Valeur système : {value} / 10. L’override est tracé et justifié.',
      value: 'Valeur corrigée (0–10)',
      preview: 'Aperçu · score revu : {before} → {after}',
      systemPreview: 'Score système inchangé : {value}',
      note: 'L’override reste actif après rescoring ; il peut être désactivé, jamais supprimé.',
      submit: 'Corriger',
      done: 'Axe corrigé.',
      section: 'Overrides',
      empty: 'Aucun override actif.',
      disable: 'Désactiver',
      disabledCount: '{count} override(s) désactivé(s)',
    },
    chart: {
      series: '{label} : {total} recherches sur {months} mois',
      empty: 'Aucune série mensuelle.',
    },
    refreshSerp: {
      title: 'Rafraîchir les SERPs',
      description: '{count} mot(s)-clé(s) représentatif(s) seront ré-interrogés en mode live.',
      reanalyze: 'Ré-analyser ensuite',
      serpLine: 'SERP live',
      submit: 'Rafraîchir',
    },
    reanalyze: {
      title: 'Ré-analyser l’opportunité',
      description: 'Une nouvelle analyse profonde sera lancée avec les preuves à jour.',
      submit: 'Ré-analyser',
    },
    events: {
      created: 'a créé l’opportunité',
      statusChanged: 'a passé le statut de',
      override: 'a corrigé l’axe {axis} :',
      overrideDisabled: 'a désactivé l’override de l’axe {axis}',
      rescored: 'rescoring : {from} → {to} (configuration v{version})',
      fieldEdited: 'a modifié',
      fromTo: '{from} → {to}',
      assigned: 'a assigné l’opportunité à {owner}',
      unassigned: 'a retiré l’owner',
      merged: 'a fusionné l’opportunité dans {target}',
      reanalyzed: 'a lancé une ré-analyse',
      serpRefreshed: 'a rafraîchi {count} SERP(s)',
      experimentCreated: 'a préparé une expérience',
      experimentUpdated: 'a mis à jour l’expérience',
      outcomeUpdated: 'a mis à jour les résultats produit',
    },
    detail: {
      tabs: 'Sections de la fiche',
      tab_overview: 'Aperçu',
      tab_demand: 'Demande',
      tab_supply: 'Offre',
      tab_analysis: 'Analyse',
      tab_experiments: 'Expériences',
      tab_activity: 'Activité',
      hypothesis: 'Hypothèse',
      dominantSolutions: 'Solutions dominantes',
      unmetNeeds: 'Besoins non couverts',
      assign: 'Assigner',
      addTags: 'Ajouter des tags',
      mergedInto: 'Fusionnée dans',
      parked: 'Mise de côté.',
      parkedUntil: 'Mise de côté jusqu’au {date}.',
      resume: 'Reprendre',
      resumeRationale: 'Reprise de l’opportunité mise de côté.',
      archived: 'Archivée : la fiche est en lecture seule.',
      noScoreTitle: 'Pas de score système',
      noScoreDescription: 'Rattachez un cluster ou lancez une analyse pour obtenir un score.',
      noClusterTitle: 'Aucun cluster rattaché',
      noClusterDescription: 'Une opportunité manuelle n’a ni métriques ni mots-clés.',
      heterogeneous:
        'Les SERPs des mots-clés représentatifs se recouvrent peu : le cluster mélange peut-être plusieurs jobs.',
      monthlyVolume: 'Volume mensuel',
      allKeywords: 'Tous les {count} mots-clés',
      evidencePack: 'Pack de preuves (entrée)',
      noOutput: 'Aucune sortie exploitable pour cette analyse.',
      llmConfidence: 'Confiance du modèle : {value}',
      subScores: 'Sous-scores',
      compare: 'Comparer deux analyses',
      compareWith: 'Comparer avec…',
      delta: 'Delta',
      tier: 'Niveau',
      tier_triage: 'Triage',
      tier_deep: 'Analyse profonde',
      llm_ok: 'Valide',
      llm_invalid: 'Invalide',
      llm_failed: 'En échec',
      model: 'Modèle',
      promptVersion: 'Version de prompt',
      noExperimentTitle: 'Aucune expérience',
      noExperimentDescription: 'Préparez une validation pour tester l’hypothèse.',
      experimentsUnavailable:
        'La création d’expérience n’est pas encore disponible (route livrée par une tâche suivante).',
      comment: 'Commentaire',
      commentPlaceholder: 'Ajouter un commentaire…',
      commentHint: 'Cmd/Ctrl + Entrée pour envoyer.',
      commentSubmit: 'Commenter',
      jobStarted: 'Traitement lancé.',
      jobDone: 'Traitement terminé.',
    },
  },
  experiments: {
    title: 'Expériences',
    count: 'Expériences · {count}',
    locked: 'Figés à la planification',
    prepareDisabled:
      'Une validation se prépare depuis une opportunité shortlistée ou non concluante.',
    status: {
      draft: 'Brouillon',
      planned: 'Planifiée',
      running: 'En cours',
      completed: 'Terminée',
      aborted: 'Abandonnée',
    },
    verdict: {
      validated: 'Validée',
      invalidated: 'Invalidée',
      inconclusive: 'Non concluante',
    },
    columns: {
      name: 'Nom',
      status: 'Statut',
      budget: 'Budget',
      start: 'Début',
      verdict: 'Verdict',
      owner: 'Owner',
    },
    filters: {
      status: 'Statut',
    },
    presets: {
      running: 'En cours',
      planned: 'Planifiées',
      completed: 'Terminées',
    },
    empty: {
      title: 'Aucune expérience',
      description:
        'Préparez une validation depuis une opportunité shortlistée pour tester la demande.',
      action: 'Voir les opportunités shortlistées',
      filteredTitle: 'Aucune expérience ne correspond',
      filteredDescription: 'Élargissez les filtres pour retrouver des expériences.',
      opportunityTitle: 'Aucune expérience',
      opportunityDescription:
        'Préparez une validation pour figer une hypothèse, des requêtes et des seuils.',
    },
    sections: {
      hypothesis: 'Hypothèse',
      targeting: 'Ciblage',
      budget: 'Budget et seuils',
      results: 'Résultats',
      brief: 'Brief',
    },
    fields: {
      name: 'Nom de l’expérience',
      hypothesis: 'Hypothèse',
      segment: 'Segment visé',
      valueProposition: 'Proposition de valeur',
      landingUrl: 'URL de la landing',
      copyNotes: 'Notes de copy',
      copyNotesHint:
        'Décrivez les annonces et la landing pour distinguer plus tard « l’offre ne convainc pas » de « l’annonce était mauvaise ».',
      plannedStart: 'Début prévu',
      plannedEnd: 'Fin prévue',
      budgetPlannedUsd: 'Budget planifié ($)',
      budgetHint: 'Suggestion : max(150, 30 × CPC moyen), plafond 400.',
    },
    actions: {
      plan: 'Planifier',
      start: 'Démarrer',
      verdict: 'Rendre le verdict',
      abort: 'Abandonner',
      viewOpportunity: 'Voir l’opportunité',
    },
    plan: {
      title: 'Planifier l’expérience ?',
      description: 'Les seuils, le budget et les mots-clés seront figés.',
      met: 'Prérequis rempli',
      missing: 'Prérequis manquant',
      requirements: {
        keywords: 'Au moins une requête ciblée',
        budget: 'Budget planifié supérieur à 0',
        thresholds: 'Seuils valides (échec plus exigeant que succès)',
        hypothesis: 'Hypothèse et segment renseignés',
      },
    },
    abort: {
      title: 'Abandonner l’expérience ?',
      description:
        'L’expérience sera close et l’opportunité redeviendra shortlistée. Justifiez la décision.',
    },
    verdictDialog: {
      title: 'Rendre le verdict',
      description: 'Le verdict est propagé à l’opportunité et clôt l’expérience.',
      recap: 'Récapitulatif des seuils',
      value: 'Valeur',
      suggestion: 'Suggestion du radar : {verdict}',
      choose: 'Verdict',
      rationaleHint: '{min} caractères minimum.',
      submit: 'Rendre le verdict',
    },
    thresholds: {
      title: 'Seuils pré-enregistrés',
      metric: 'Métrique',
      fail: 'Seuil d’échec',
      success: 'Seuil de succès',
      suggestion: 'Suggestion',
      reset: 'Reprendre',
      resetAll: 'Tout reprendre',
      resetRow: 'Reprendre la suggestion pour {metric}',
      failOf: 'Seuil d’échec — {metric}',
      successOf: 'Seuil de succès — {metric}',
      expectedCpc: 'CPC attendu',
      invalid: 'Le seuil d’échec doit rester sous le seuil de succès.',
      invalidInverted: 'Le seuil d’échec doit rester au-dessus du seuil de succès.',
      cpaTarget: 'CPA cible : ≤ {multiplier} × CPC attendu = {amount}.',
      noCpc: 'CPC attendu inconnu : le CPA ne sera pas évalué.',
      rows: {
        impressions: 'Impressions',
        ctr: 'CTR',
        cvr: 'Conversion',
        cpa: 'Coût par action',
        strong: 'Signaux forts',
      },
      hints: {
        impressions: 'Sous ce volume, l’expérience reste non concluante.',
        ctr: 'Clics / impressions sur les requêtes exactes.',
        cvr: 'Actions / visites (inscriptions et signaux forts).',
        cpa: 'Multiplicateur du CPC attendu.',
        strong: 'Entretiens, précommandes, démos, dépôts.',
      },
    },
    results: {
      funnel: 'Funnel publicitaire',
      landing: 'Landing',
      strongSignals: 'Signaux forts',
      qualitative: 'Qualitatif',
      evaluation: 'Évaluation des seuils',
      updatedAt: 'Résultats mis à jour {when}',
      verdictRendered: 'Le verdict a été rendu le {when} : il ne sera pas recalculé.',
      suggestionTitle: 'Suggestion de verdict : {verdict}',
      strongTotal: 'Total des signaux forts : {count}',
      clicksAboveImpressions: 'Les clics ne peuvent pas dépasser les impressions.',
      engagedAboveVisits: 'Les visites engagées ne peuvent pas dépasser les visites.',
      addItem: 'Ajouter',
      removeItem: 'Retirer {item}',
      emptyList: 'Aucune entrée',
      fields: {
        impressions: 'Impressions',
        clicks: 'Clics',
        cost_usd: 'Coût ($)',
        visits: 'Visites',
        engaged_visits: 'Visites engagées',
        signups: 'Inscriptions',
      },
      signals: {
        interviews: 'Entretiens',
        preorders: 'Précommandes',
        demo_requests: 'Demandes de démo',
        deposits: 'Dépôts',
        other: 'Autres',
      },
      derived: {
        ctr: 'CTR',
        avgCpc: 'CPC moyen',
        cpa: 'Coût par action',
      },
      states: {
        fail: 'seuil d’échec franchi ({fail})',
        between: 'entre échec ({fail}) et succès ({success})',
        success: 'seuil de succès atteint ({success})',
        unknown: 'non évaluable',
      },
      qualitativeFields: {
        learnings: 'Apprentissages',
        quotes: 'Citations',
        objections: 'Objections',
      },
      qualitativePlaceholders: {
        learnings: 'Ce que l’expérience a appris…',
        quotes: 'Une phrase entendue…',
        objections: 'Un frein exprimé…',
      },
    },
    targeting: {
      addTitle: 'Ajouter des mots-clés',
      addDescription:
        'Mots-clés du cluster de l’opportunité, ou saisie libre (volume et CPC inconnus).',
      searchPlaceholder: 'Rechercher ou saisir un mot-clé…',
      noKeyword: 'Aucun mot-clé',
      clusterKeywords: 'Mots-clés du cluster',
      addFree: 'Ajouter la saisie',
      selected: '{count} sélectionné(s)',
      confirm: 'Ajouter au ciblage',
      empty: 'Aucune requête ciblée : ajoutez-en au moins une avant de planifier.',
    },
    brief: {
      open: 'Ouvrir',
      error: 'Le brief n’a pas pu être chargé.',
    },
    toast: {
      saved: 'Expérience enregistrée',
      resultsSaved: 'Résultats enregistrés',
      planned: 'Expérience planifiée : seuils, budget et requêtes figés',
      running: 'Expérience démarrée',
      aborted: 'Expérience abandonnée',
      verdict: 'Verdict rendu : {verdict}',
    },
  },
  outcomes: {
    title: 'Résultats produit',
    saved: 'Résultats produit enregistrés',
    addMetric: 'Ajouter',
    removeMetric: 'Retirer {metric}',
    emptyMetrics: 'Aucune métrique',
    groups: {
      activation: 'Activation',
      retention: 'Rétention',
      acquisition: 'Acquisition',
      revenue: 'Revenu',
    },
    fields: {
      buildStartedAt: 'Début du build',
      launchedAt: 'Lancement',
      buildDays: 'Jours de build',
      buildCostUsd: 'Coût du build ($)',
      metric: 'Métrique',
      value: 'Valeur',
      period: 'Période',
      notes: 'Notes',
    },
  },
  clusters: {
    title: 'Clusters',
    count: 'Clusters · {count}',
    search: 'Rechercher un cluster…',
    breadcrumb: 'Clusters',
    eligibility: {
      pending: 'En attente',
      excluded: 'Exclu',
      ineligible: 'Inéligible',
      candidate: 'Candidat',
    },
    stage: {
      formed: 'Formé',
      prefiltered: 'Préfiltré',
      triaged: 'Trié',
      enriched: 'Enrichi',
      analyzed: 'Analysé',
    },
    rules: {
      exclusion: 'G1 exclusion',
      low_demand: 'G2 demande faible',
      informational: 'G3 informationnel',
      news_local: 'G4 actualité ou local',
      untestable: 'G5 non testable',
      triage: 'G6 triage',
      brand: 'G7 marque',
    },
    columns: {
      label: 'Libellé',
      market: 'Marché',
      stage: 'Étape',
      eligibility: 'Éligibilité',
      priority: 'Priorité',
      triage: 'Triage',
      volume: 'Volume',
      bidHigh: 'Enchère haute ($)',
      keywords: 'Mots-clés',
      opportunity: 'Opportunité',
      updatedAt: 'Mis à jour',
    },
    filters: {
      stage: 'Étape',
      eligibility: 'Éligibilité',
      minPriority: 'Priorité min',
      hasOpportunity: 'Avec opportunité',
    },
    presets: {
      candidates: 'Candidats',
      discarded: 'Exclus et inéligibles',
      analyzed: 'Analysés',
    },
    truncated:
      'Plusieurs valeurs sélectionnées : affichage limité aux {max} premiers clusters par valeur.',
    empty: {
      title: 'Aucun cluster',
      description: 'Lancez un scan pour former les premiers clusters.',
      action: 'Lancer un scan',
      filteredTitle: 'Aucun cluster ne correspond',
      filteredDescription: 'Modifiez ou effacez les filtres pour élargir la recherche.',
    },
    header: {
      priority: 'Priorité {value}',
      triage: 'Triage {value}/10',
      opportunity: 'Opportunité',
      opportunityLink: 'Opportunité : {title}',
      softFlag: 'Drapeau {flag}',
      heterogeneous:
        'SERPs hétérogènes : les mots-clés représentatifs ne partagent pas les mêmes résultats.',
      primaryKeyword: 'Mot-clé primaire : {text}',
    },
    banner: {
      merged: 'Fusionné dans',
    },
    reasons: {
      title: 'Raisons d’éligibilité',
    },
    triage: {
      title: 'Triage',
      jobStatement: 'Job',
      noJob: 'Pas un job',
      intent: 'Intention',
      productType: 'Type de produit',
      brandDominated: 'Dominé par une marque',
      digitalProduct: 'Produit numérique possible',
      exclusionCategory: 'Catégorie d’exclusion',
      reason: 'Raison',
      confidence: 'Confiance',
      score: 'Score de triage',
    },
    intent: {
      task: 'Tâche',
      tool: 'Outil',
      comparison: 'Comparaison',
      purchase: 'Achat',
      informational: 'Informationnel',
      navigational: 'Navigationnel',
      mixed: 'Mixte',
    },
    productType: {
      web_app: 'Web app',
      browser_extension: 'Extension',
      api: 'API',
      mobile_app: 'Mobile',
      none: 'Aucun',
    },
    exclusionCategory: {
      none: 'Aucune',
      adult: 'Adulte',
      gambling: 'Jeux d’argent',
      health: 'Santé',
      finance: 'Finance',
      legal: 'Juridique',
      other_risky: 'Autre risque',
    },
    metrics: {
      title: 'Métriques',
      pending: 'Les métriques seront calculées à la fin de la phase « Métriques » du scan.',
      volumeSum: 'Volume total',
      volumeSumHint:
        'Somme des volumes mensuels des mots-clés primaires. Borne haute : les recoupements entre requêtes ne sont pas corrigés.',
      volumeMax: 'Volume max',
      volumeMaxHint: 'Volume mensuel du mot-clé le plus fort du cluster.',
      keywordCount: 'Mots-clés',
      keywordCountHint:
        'Nombre de mots-clés primaires ; les variantes lexicales ne sont pas comptées.',
      cpcWeighted: 'CPC pondéré ($)',
      cpcWeightedHint:
        'Moyenne du CPC pondérée par le volume, en USD. Repli sur le milieu des enchères quand le CPC manque.',
      bids: 'Enchères p50 basse / haute ($)',
      bidsHint:
        'Médianes des enchères haut de page (20e et 80e percentiles) des mots-clés primaires, en USD.',
      competition: 'Indice de concurrence',
      competitionHint: 'Moyenne pondérée par le volume de l’indice Google Ads (0–100).',
      taskVerbRatio: 'Verbes de tâche',
      taskVerbRatioHint: 'Part du volume portée par des mots-clés contenant un verbe de tâche.',
      modifierRatio: 'Modificateurs',
      modifierRatioHint:
        'Part du volume avec un modificateur produit (software, tool, app, generator, logiciel, outil…).',
      questionRatio: 'Questions',
      questionRatioHint: 'Part du volume en formulation interrogative.',
      brandRatio: 'Marque',
      brandRatioHint:
        'Part du volume jugée navigationnelle (marque), estimée par le triage puis par les SERPs.',
      trend: 'Tendance',
      trendHint:
        'Pente relative mensuelle de la somme des volumes (moindres carrés / moyenne) : +3 % = +3 % par mois.',
      seasonality: 'Saisonnalité',
      seasonalityHint: '(max − min) / moyenne des volumes mensuels agrégés. 0 = demande stable.',
      historyMonths: 'Mois d’historique',
      historyMonthsHint: 'Nombre de mois d’historique disponibles, 12 au plus.',
      monthlySeries: 'Série mensuelle',
      monthlySeriesHint: 'Somme des volumes mensuels des mots-clés primaires sur 12 mois.',
      monthlySeriesEmpty: 'Historique mensuel indisponible.',
    },
    supply: {
      title: 'Offre (SERPs)',
      serpCount: 'SERPs analysées',
      serpCountHint: 'Nombre de SERPs analysées pour le cluster (3 au plus).',
      toolRatio: 'Outils',
      toolRatioHint: 'Part des 10 premiers résultats organiques classés outil ou SaaS.',
      contentRatio: 'Articles',
      contentRatioHint: 'Part des 10 premiers résultats organiques classés article.',
      ugcRatio: 'Forums',
      ugcRatioHint: 'Part classée forum (Reddit, Quora, Stack Exchange…).',
      marketplaceRatio: 'Places de marché',
      marketplaceRatioHint: 'Part classée place de marché ou annuaire.',
      bigBrandRatio: 'Grandes plateformes',
      bigBrandRatioHint: 'Part provenant de plateformes dominantes (Google, Microsoft, Adobe…).',
      domainConcentration: 'Concentration',
      domainConcentrationHint:
        'Part des 10 positions détenues par les deux domaines les plus présents.',
      adsTopAvg: 'Annonces en haut',
      adsTopAvgHint: 'Nombre moyen d’annonces au-dessus des résultats organiques.',
      adsAnyRatio: 'SERPs avec annonces',
      adsAnyRatioHint: 'Part des SERPs contenant au moins une annonce.',
      paaCount: 'Questions PAA',
      paaCountHint: 'Nombre moyen de questions « autres questions posées ».',
      overlapWithin: 'Recouvrement',
      overlapWithinHint:
        'Recouvrement moyen d’URL entre les SERPs des mots-clés représentatifs (cohérence du cluster).',
    },
    tabs: {
      keywords: 'Mots-clés',
      serp: 'SERPs',
      analyses: 'Analyses',
    },
    keywords: {
      summary: '{primaries} primaires · {variants} variantes',
      truncatedHint:
        'Les {count} premiers primaires par volume ; le tri et la pagination chargent le reste.',
    },
    serp: {
      snapshot: 'SERP',
      emptyTitle: 'Aucune SERP analysée pour ce cluster',
      emptyDescription: 'Les SERPs sont achetées à l’enrichissement pour les clusters retenus.',
      refresh: 'Rafraîchir les SERPs',
      refreshUnavailable: 'Disponible après l’enrichissement',
    },
    analyses: {
      emptyTitle: 'Aucune analyse',
      emptyDescription: 'Les analyses LLM apparaissent après le triage et l’analyse profonde.',
      columns: {
        tier: 'Niveau',
        model: 'Modèle',
        promptVersion: 'Prompt',
        status: 'Statut',
        cost: 'Coût ($)',
        createdAt: 'Date',
      },
      tier: {
        triage: 'Triage',
        deep: 'Analyse profonde',
      },
      status: {
        ok: 'OK',
        invalid: 'Invalide',
        failed: 'En échec',
      },
      open: 'Ouvrir l’analyse {id}',
      sheetTitle: 'Analyse {tier}',
      sheetDescription: '{model} · {promptVersion} · {createdAt}',
      input: 'Entrée',
      output: 'Sortie',
      error: 'Erreur',
      unavailable: 'Non disponible',
    },
    suggestions: {
      title: 'Suggestions de fusion',
      target: 'Cluster cible',
      overlap: 'Recouvrement {value}',
      merge: 'Fusionner',
      dismiss: 'Ignorer',
      dismissed: 'Suggestion ignorée',
    },
    actions: {
      promote: 'Promouvoir en opportunité',
      merge: 'Fusionner dans…',
      reanalyze: 'Ré-analyser',
      reanalyzeTitle: 'Ré-analyser le cluster ?',
      reanalyzeDescription:
        'Une analyse profonde sera relancée avec les données actuelles. Coût estimé : {cost}. Reste du mois : {remaining}.',
      reanalyzeConfirm: 'Lancer la ré-analyse',
      reanalyzeStarted: 'Ré-analyse lancée',
      reanalyzeExisting: 'Une ré-analyse est déjà en cours pour ce cluster',
      mergedDisabled: 'Cluster fusionné : actions désactivées',
    },
    promote: {
      title: 'Promouvoir en opportunité',
      description:
        'L’opportunité est créée manuellement à partir du cluster ; elle sera scorée avec les données disponibles.',
      warning:
        'Ce cluster est {status} : {reasons}. La promotion est tracée avec votre justification.',
      titleField: 'Titre',
      canonicalJob: 'Job canonique',
      targetSegment: 'Segment cible',
      productType: 'Type de produit',
      submit: 'Promouvoir',
      success: 'Opportunité créée',
      conflict: 'Ce cluster est déjà lié à une opportunité.',
    },
    merge: {
      title: 'Fusionner le cluster',
      description: 'Les mots-clés de « {label} » seront transférés dans le cluster cible.',
      success: 'Cluster fusionné',
    },
  },
  keywords: {
    columns: {
      text: 'Mot-clé',
      volume: 'Volume',
      bidHigh: 'Enchère haute ($)',
      competition: 'Concurrence',
      trend: 'Tendance',
      matchType: 'Correspondance',
      actions: 'Actions',
    },
    features: {
      task_verb: 'tâche',
      modifier: 'modificateur',
      question: 'question',
      file_format: 'format',
      price: 'prix',
      informational: 'info',
      brand: 'marque',
    },
    representative: 'Mot-clé représentatif',
    variants_one: '{count} variante',
    variants_other: '{count} variantes',
    expandVariants: 'Afficher les variantes de {text}',
    collapseVariants: 'Masquer les variantes de {text}',
    variantRow: 'Variante',
    matchType: {
      exact: 'Exacte',
      phrase: 'Expression',
    },
    remove: 'Retirer {text}',
    add: 'Ajouter un mot-clé',
    empty: 'Aucun mot-clé',
    list: 'Mots-clés',
  },
  merge: {
    title: {
      cluster: 'Fusionner dans un cluster',
      opportunity: 'Fusionner dans une opportunité',
    },
    search: {
      cluster: 'Rechercher un cluster du marché…',
      opportunity: 'Rechercher une opportunité du marché…',
    },
    target: 'Cible',
    noResults: 'Aucun résultat',
    searching: 'Recherche…',
    selectTarget: 'Choisissez une cible',
    change: 'Changer',
    warning: {
      cluster: 'Irréversible : les mots-clés sont transférés et le centroïde recalculé.',
      opportunity: 'Irréversible : l’opportunité sera marquée fusionnée.',
    },
    submit: 'Fusionner',
  },
  sparkline: {
    label: 'Tendance {trend}',
    labelNoSlope: 'Tendance sur {count} mois',
    insufficient: 'Tendance indisponible (moins de 3 points)',
  },
  serp: {
    fetchedAt: 'Collectée {relative}',
    mode: {
      standard: 'Standard',
      live: 'Live',
    },
    results_one: '{count} résultat',
    results_other: '{count} résultats',
    ads: 'Annonces',
    adsCount_one: '{count} annonce en haut de page',
    adsCount_other: '{count} annonces en haut de page',
    noAds: 'Aucune annonce',
    organic: 'Résultats organiques',
    paa: 'Autres questions posées',
    featuredSnippet: 'Extrait optimisé',
    rank: 'Rang {rank}',
    open: 'Ouvrir {title}',
    class: {
      tool: 'outil',
      saas: 'SaaS',
      article: 'article',
      forum: 'forum',
      marketplace: 'place de marché',
      directory: 'annuaire',
      brand: 'marque',
      video: 'vidéo',
      government: 'public',
      other: 'autre',
    },
    empty: 'Aucun résultat organique',
  },
  jobs: {
    status: {
      queued: 'En attente',
      running: 'En cours',
      done: 'Terminé',
      failed: 'En échec',
    },
    view: 'Voir',
    failed: 'Le traitement a échoué : {error}',
  },
  auth: {
    login: {
      title: 'Connexion',
      subtitle: 'Connectez-vous pour accéder au radar.',
      email: 'Email',
      password: 'Mot de passe',
      submit: 'Se connecter',
      forgot: 'Mot de passe oublié',
      invalid: 'Email ou mot de passe incorrect',
      banned: 'Compte désactivé',
    },
    invite: {
      title: 'Créer votre compte',
      subtitle: 'Vous avez été invité à rejoindre Elvn Radar.',
      name: 'Nom',
      password: 'Mot de passe',
      confirm: 'Confirmation du mot de passe',
      passwordHint: '{min} caractères minimum · {length}/{min}',
      submit: 'Créer le compte',
    },
    reset: {
      title: 'Réinitialiser le mot de passe',
      requestSubtitle: 'Indiquez votre email, nous vous enverrons un lien de réinitialisation.',
      newSubtitle: 'Choisissez un nouveau mot de passe.',
      email: 'Email',
      submitRequest: 'Envoyer le lien',
      sent: 'Si un compte existe, un email a été envoyé.',
      newPassword: 'Nouveau mot de passe',
      confirm: 'Confirmation du mot de passe',
      submitReset: 'Enregistrer le mot de passe',
      done: 'Mot de passe réinitialisé, vous pouvez vous connecter.',
      failed: 'Ce lien de réinitialisation n’est plus valide, demandez-en un nouveau.',
      backToLogin: 'Retour à la connexion',
    },
    logout: 'Se déconnecter',
  },
  shell: {
    market: {
      label: 'Marché',
      placeholder: 'Choisir un marché',
      disabledHint: 'Cet écran n’est pas partitionné par marché',
    },
    budget: {
      label: 'Budget du mois',
      of: '{spent} / {cap}',
      unknown: '—',
      open: 'Voir les coûts',
    },
    theme: {
      label: 'Thème',
      system: 'Système',
      light: 'Clair',
      dark: 'Sombre',
    },
    user: {
      menu: 'Menu utilisateur',
      role: {
        admin: 'Administrateur',
        member: 'Membre',
      },
    },
    narrowScreen: 'Utilisez un écran plus large (1024 px minimum).',
  },
  settings: {
    title: 'Paramètres',
    readOnly: 'Lecture seule',
    readOnlyHint: 'Seuls les administrateurs peuvent modifier ces réglages.',
    nav: {
      label: 'Sections des paramètres',
      scoring: 'Scoring',
      budget: 'Budget',
      exclusions: 'Exclusions',
      users: 'Utilisateurs',
      costs: 'Coûts',
      account: 'Compte',
    },
    scoring: {
      title: 'Configurations de scoring',
      description:
        'Poids des axes A–G et paramètres du score. Une seule version est active ; les scans et le rescoring l’utilisent.',
      newVersion: 'Nouvelle version',
      rescoreAll: 'Rescorer tout',
      columns: {
        version: 'Version',
        active: 'Active',
        notes: 'Notes',
        author: 'Auteur',
        createdAt: 'Créée',
      },
      versionLabel: 'v{version}',
      activeBadge: 'Active',
      inactiveBadge: 'Inactive',
      seed: 'Seed initial',
      selectRow: 'Voir la version {version}',
      empty: 'Aucune configuration de scoring.',
      detail: {
        title: 'Version {version}',
        weights: 'Poids des axes',
        axis: 'Axe',
        axisLabel: 'Libellé de l’axe',
        weight: 'Poids',
        params: 'Paramètres',
        notes: 'Notes',
        createdBy: 'Créée par {name} · {date}',
        sections: {
          anchors: 'Ancres de volume',
          multipliers: 'Multiplicateurs',
          thresholds: 'Seuils',
          default_caps: 'Plafonds par défaut',
          lists: 'Listes',
          other: 'Autres paramètres',
        },
      },
      activate: 'Activer',
      duplicate: 'Dupliquer en nouvelle version',
      activateDialog: {
        title: 'Activer la version {version} ?',
        description: 'Les prochains scans et rescoring l’utiliseront.',
        confirm: 'Activer la version {version}',
      },
      activated: 'Version {version} activée',
      form: {
        title: 'Nouvelle version de scoring',
        description:
          'La version est créée inactive : activez-la ensuite, puis lancez un rescoring si nécessaire.',
        weights: 'Poids des axes (somme = 1)',
        weightLabel: 'Poids de l’axe {axis} · {label}',
        sum: 'Somme : {sum}',
        sumOk: 'somme valide',
        sumKo: 'somme invalide',
        params: 'Paramètres (JSON)',
        paramsHint:
          'Validé par le schéma ScoringParams à la saisie ; chaque erreur indique son chemin.',
        paramsValid: 'JSON valide',
        paramsErrors_one: '{count} erreur',
        paramsErrors_other: '{count} erreurs',
        notes: 'Notes',
        notesHint: 'Pourquoi cette version ? Obligatoire.',
        submit: 'Créer la version',
        created: 'Version {version} créée (inactive)',
      },
      rescore: {
        title:
          'Rescorer toutes les opportunités non archivées avec la version active (v{version}) ?',
        count_one: '{count} opportunité concernée.',
        count_other: '{count} opportunités concernées.',
        countUnknown: 'Nombre d’opportunités concernées indisponible.',
        reminder: 'Les overrides restent actifs ; un événement est créé par opportunité.',
        confirm: 'Rescorer tout',
        started: 'Rescoring lancé',
        existing: 'Un rescoring est déjà en cours.',
        running: 'Rescoring en cours…',
        done: 'Rescoring terminé',
        doneAction: 'Voir les opportunités',
        failed: 'Le rescoring a échoué : {error}',
      },
    },
    budget: {
      title: 'Budget',
      description: 'Plafonds de dépense mensuels et par scan ; seuil d’alerte de l’indicateur.',
      currentMonth: 'Mois en cours',
      monthlyCap: 'Plafond mensuel ($)',
      scanCap: 'Plafond par scan ($)',
      warnRatio: 'Seuil d’alerte (%)',
      warnRatioHint: 'Pourcentage du plafond mensuel à partir duquel l’indicateur passe en alerte.',
      saved: 'Budget enregistré',
      notifications: {
        title: 'Notifications',
        description: 'Emails envoyés à la fin d’un scan et quand le budget approche du plafond.',
        onScanCompleted: 'Scan terminé',
        onBudgetWarning: 'Alerte budget',
        recipients: 'Destinataires',
        recipientsHint: 'Entrée ou virgule pour ajouter un email.',
        recipientsPlaceholder: 'email@exemple.com',
        addRecipient: 'Ajouter le destinataire',
        removeRecipient: 'Retirer {email}',
        saved: 'Notifications enregistrées',
        emailConfigured: 'Envoi d’emails : configuré',
        emailNotConfigured: 'Envoi d’emails : non configuré',
      },
      providers: {
        title: 'Fournisseurs',
        description: 'Aucune clé n’est affichée : seul l’état de configuration est connu.',
        configured: 'Configuré',
        notConfigured: 'Non configuré',
        keywordProvider: 'Source des mots-clés',
        keywordProviderHint:
          'Données Google Keyword Planner via DataForSEO (0,09 $ par requête) ; Google Ads reste sélectionnable par KEYWORD_PROVIDER.',
        google_ads: 'Google Ads',
        dataforseo: 'DataForSEO',
        openai: 'OpenAI',
        resend: 'Resend',
      },
    },
    exclusions: {
      title: 'Termes d’exclusion',
      count: 'Termes d’exclusion · {count}',
      description:
        'Termes qui excluent un cluster avant tout appel payant (portes G1) ou posent un drapeau de risque (soft).',
      add: 'Ajouter un terme',
      nextScan: 'Les nouveaux termes s’appliquent au prochain scan.',
      regexHint: 'Un motif regex est appliqué sur un texte sans accents ni majuscules.',
      columns: {
        term: 'Terme',
        category: 'Catégorie',
        market: 'Marché',
        match: 'Correspondance',
        soft: 'Soft',
        createdBy: 'Ajouté par',
        createdAt: 'Date',
      },
      filters: {
        category: 'Catégorie',
        market: 'Marché',
        active: 'Actif',
      },
      allMarkets: 'Tous',
      seed: 'Seed initial',
      softBadge: 'risque',
      inactiveBadge: 'Désactivé',
      category: {
        adult: 'Adulte',
        gambling: 'Jeux d’argent',
        health: 'Santé',
        finance: 'Finance',
        legal: 'Juridique',
        custom: 'Personnalisé',
      },
      match: {
        word: 'Mot entier',
        contains: 'Contient',
        regex: 'Regex',
      },
      empty: {
        title: 'Aucun terme ne correspond',
        description: 'Modifiez ou effacez les filtres.',
      },
      form: {
        title: 'Ajouter un terme',
        description: 'Le terme s’applique aux prochains scans, pas aux clusters déjà évalués.',
        category: 'Catégorie',
        market: 'Marché',
        term: 'Terme',
        termHint: 'Minuscules forcées, sauf pour un motif regex.',
        match: 'Correspondance',
        matchHint: {
          word: 'Mot ou expression entière (« bet » ne matche pas « alphabet »).',
          contains: 'Sous-chaîne, accents et casse ignorés.',
          regex: 'Motif appliqué en insensible à la casse sur le texte sans accents.',
        },
        preview: 'Tester sur un mot-clé',
        previewPlaceholder: 'ex. convert bank statement',
        previewMatch: 'Correspond',
        previewNoMatch: 'Ne correspond pas',
        previewInvalid: 'Motif invalide : {message}',
        isSoft: 'Drapeau de risque (soft)',
        isSoftHint: 'Drapeau de risque (axe G), n’exclut pas.',
        submit: 'Ajouter',
        created: 'Terme ajouté',
      },
      remove: {
        deleteTitle: 'Supprimer le terme « {term} » ?',
        deactivateTitle: 'Désactiver le terme « {term} » ?',
        deleteDescription: 'Ce terme a été ajouté par un administrateur ; il sera supprimé.',
        deactivateDescription:
          'Ce terme fait partie du seed initial ; il sera désactivé, jamais supprimé.',
        delete: 'Supprimer',
        deactivate: 'Désactiver',
        deleted: 'Terme supprimé',
        deactivated: 'Terme désactivé',
      },
    },
    users: {
      title: 'Utilisateurs',
      count: 'Utilisateurs · {count}',
      invite: 'Inviter',
      columns: {
        name: 'Nom',
        email: 'Email',
        role: 'Rôle',
        banned: 'Banni',
        lastSession: 'Dernière session',
      },
      role: {
        admin: 'Administrateur',
        member: 'Membre',
      },
      roleSelect: 'Rôle de {name}',
      banSwitch: 'Bannir {name}',
      never: 'Jamais',
      roleChanged: 'Rôle mis à jour',
      banned: 'Utilisateur banni',
      unbanned: 'Utilisateur réactivé',
      banReason: 'Raison : {reason}',
      empty: 'Aucun utilisateur.',
      ban: {
        title: 'Bannir {name} ?',
        description: 'Ses sessions seront révoquées et toute connexion refusée.',
        reason: 'Raison',
        reasonHint: 'Obligatoire, conservée dans le journal d’audit.',
        confirm: 'Bannir',
      },
      setPassword: {
        menu: 'Définir un mot de passe temporaire',
        title: 'Définir un mot de passe temporaire pour {name} ?',
        description:
          'Un mot de passe de 20 caractères sera généré et ses sessions révoquées. Il ne sera affiché qu’une seule fois.',
        confirm: 'Générer',
        resultTitle: 'Mot de passe temporaire',
        resultDescription: 'Transmettez-le de façon sécurisée ; il ne sera plus affiché.',
        password: 'Mot de passe temporaire de {name}',
      },
      invitations: {
        title: 'Invitations en attente',
        empty: 'Aucune invitation en attente.',
        columns: {
          email: 'Email',
          role: 'Rôle',
          expires: 'Expire',
          invitedBy: 'Invité par',
        },
        expired: 'Expirée',
        revoke: 'Révoquer',
        revokeTitle: 'Révoquer l’invitation de {email} ?',
        revokeDescription: 'Le lien envoyé ne fonctionnera plus.',
        revoked: 'Invitation révoquée',
        linkUnavailable: 'Lien disponible uniquement à la création',
      },
      inviteDialog: {
        title: 'Inviter un utilisateur',
        description: 'L’invitation est valable 7 jours ; le lien n’est affiché qu’à la création.',
        email: 'Email',
        role: 'Rôle',
        sendEmail: 'Envoyer l’email d’invitation',
        sendEmailDisabledHint:
          'Envoi désactivé : Resend n’est pas configuré. Copiez le lien après création.',
        submit: 'Créer l’invitation',
        successTitle: 'Invitation créée',
        link: 'Lien d’invitation',
        copy: 'Copier le lien',
        copied: 'Lien copié',
        expiresHint: 'Ce lien expire dans 7 jours et ne sera plus affiché.',
        emailSent: 'Email envoyé à {email}.',
        emailNotSent: 'Email non envoyé : transmettez le lien vous-même.',
      },
    },
    costs: {
      title: 'Coûts',
      description: 'Dépenses réelles du mois par fournisseur et par scan, ledger détaillé.',
      month: 'Mois',
      total: 'Total',
      provider: {
        google_ads: 'Google Ads',
        dataforseo: 'DataForSEO',
        openai: 'OpenAI',
        workers_ai: 'Workers AI',
      },
      operations_one: '{count} opération',
      operations_other: '{count} opérations',
      byScan: {
        title: 'Par scan',
        columns: {
          scan: 'Scan',
          market: 'Marché',
          cost: 'Coût',
          share: 'Part',
        },
        noScan: 'Hors scan',
        filter: 'Filtrer le ledger sur le scan {label}',
        empty: 'Aucune dépense ce mois-ci.',
      },
      ledger: {
        title: 'Ledger',
        columns: {
          date: 'Date',
          provider: 'Fournisseur',
          operation: 'Opération',
          units: 'Unités',
          cost: 'Coût ($)',
          scan: 'Scan',
          target: 'Cluster / opportunité',
        },
        filters: {
          provider: 'Fournisseur',
          scan: 'Scan : {label}',
          clearScan: 'Retirer le filtre de scan',
        },
        empty: {
          title: 'Aucune ligne de coût',
          description: 'Le ledger se remplit à chaque appel externe payant.',
        },
        cluster: 'Cluster {id}',
        opportunity: 'Opportunité {id}',
      },
      audit: {
        title: 'Journal d’audit',
        description: 'Actions d’administration, plus récentes d’abord.',
        columns: {
          date: 'Date',
          actor: 'Acteur',
          action: 'Action',
          entity: 'Entité',
          data: 'Données',
        },
        system: 'Système',
        empty: 'Aucune entrée.',
      },
    },
    account: {
      title: 'Compte',
      name: 'Nom',
      namePlaceholder: 'Votre nom',
      nameSaved: 'Nom enregistré',
      email: 'Email',
      role: 'Rôle',
      password: {
        title: 'Changer le mot de passe',
        description: 'Vos autres sessions seront déconnectées.',
        current: 'Mot de passe actuel',
        new: 'Nouveau mot de passe',
        confirm: 'Confirmation du nouveau mot de passe',
        submit: 'Changer le mot de passe',
        done: 'Mot de passe modifié ; vos autres sessions ont été déconnectées.',
        invalid: 'Mot de passe actuel incorrect.',
      },
      sessions: {
        title: 'Sessions',
        description: 'Déconnecte tous les autres appareils ; cette session reste ouverte.',
        revoke: 'Déconnecter toutes les autres sessions',
        revoked: 'Autres sessions déconnectées',
      },
      preferences: {
        title: 'Préférences',
        theme: 'Thème',
        defaultMarket: 'Marché par défaut',
        defaultMarketHint: 'Marché sélectionné à l’ouverture de l’application.',
      },
    },
  },
  dashboard: {
    title: 'Tableau de bord',
    stats: {
      toTriage: 'À trier',
      shortlisted: 'Shortlistées',
      experimentsRunning: 'Expériences en cours',
      monthCost: 'Coût du mois',
      since: 'Depuis le {date} : {items}',
      newCount_one: '{count} nouvelle',
      newCount_other: '{count} nouvelles',
      rescoredCount_one: '{count} rescorée',
      rescoredCount_other: '{count} rescorées',
      decisionCount_one: '{count} décision',
      decisionCount_other: '{count} décisions',
      experimentCount_one: '{count} expérience terminée',
      experimentCount_other: '{count} expériences terminées',
    },
    toTriage: {
      title: 'À trier',
      empty: 'Aucune opportunité à trier.',
      seeAll: 'Voir les {count} opportunités à trier',
    },
    shortlist: {
      title: 'Shortlist',
      empty: 'Aucune opportunité shortlistée.',
      seeAll: 'Voir la shortlist ({count})',
    },
    experiments: {
      title: 'Expériences en cours',
      empty: 'Aucune expérience en cours.',
      seeAll: 'Voir les expériences',
      daysLeft: 'J-{days}',
      lastDay: 'Dernier jour',
      overdue: 'Dépassée de {days} j',
      noDeadline: 'Sans échéance',
    },
    scans: {
      title: 'Derniers scans',
      empty: 'Aucun scan pour l’instant.',
      newScan: 'Nouveau scan',
      seeAll: 'Voir tous les scans',
    },
    funnel: {
      title: 'Où en est l’entonnoir',
      seeds: 'Seeds actives',
      scans: 'Scans en cours',
      toTriage: 'À trier',
      shortlist: 'Shortlist',
      experiments: 'Expériences en cours',
      empty: 'L’entonnoir est vide : activez des seeds et lancez un scan.',
    },
    empty: {
      title: 'Lancez votre premier scan',
      description: 'Le tableau de bord se remplit dès que des opportunités existent.',
      action: 'Nouveau scan',
    },
  },
  calibration: {
    title: 'Calibration',
    description:
      'Scores prédits à la création, mis en regard des verdicts d’expérience et des résultats produit.',
    export: 'Exporter les analyses annotées (CSV)',
    totals: {
      experiments: 'Expériences terminées',
      validated: 'Validées',
      invalidated: 'Invalidées',
      inconclusive: 'Non concluantes',
    },
    charts: {
      data: 'Données',
      bucket: 'Tranche de score',
      band: 'Bande de confiance',
      axis: 'Axe',
      summaryItem: '{label} : {total} au total, dont {validated} validées',
      axisItem: '{axis} : validées {validated}, invalidées {invalidated}',
      scoreBuckets: {
        title: 'Verdicts par tranche de score',
        aria: 'Verdicts par tranche de score initial. {summary}',
      },
      confidenceBands: {
        title: 'Verdicts par bande de confiance',
        aria: 'Verdicts par bande de confiance initiale. {summary}',
      },
      axes: {
        title: 'Moyenne des axes par verdict',
        aria: 'Moyenne de chaque axe du score système, validées contre invalidées. {summary}',
      },
    },
    columns: {
      opportunity: 'Opportunité',
      initialScore: 'Score initial',
      currentScore: 'Score actuel',
      reviewedScore: 'Score revu',
      confidence: 'Confiance',
      verdict: 'Verdict',
      ctr: 'CTR',
      cpa: 'CPA',
      strongSignals: 'Signaux forts',
      spent: 'Dépensé',
      launchedAt: 'Lancée le',
      revenue: 'Revenu',
    },
    method: {
      body: 'Aucun ajustement automatique des poids. La première recalibration humaine est prévue après {target} expériences terminées.',
      counter: '{done} / {target} expériences terminées',
    },
    empty: {
      title: 'La calibration se remplit avec les expériences terminées',
      description:
        'Rendez un verdict sur une expérience ou saisissez un résultat produit pour voir apparaître une ligne.',
      action: 'Voir les expériences',
    },
  },
  notFound: {
    title: 'Page introuvable',
    description: 'Cette page n’existe pas ou a été déplacée.',
    backHome: 'Retour au tableau de bord',
  },
  errors: {
    title: 'Une erreur est survenue',
    validation_error: 'Vérifiez les champs en erreur.',
    unauthenticated: 'Session expirée, reconnectez-vous.',
    forbidden: 'Action réservée aux administrateurs.',
    bad_origin: 'Requête refusée : origine inconnue.',
    not_found: 'Introuvable.',
    conflict: 'Cette action entre en conflit avec l’état actuel.',
    scan_already_running: 'Un scan est déjà en cours. Attendez sa fin ou annulez-le.',
    invalid_transition: 'Cette transition n’est pas autorisée depuis le statut actuel.',
    experiment_locked: 'Ces champs sont figés depuis la planification.',
    experiment_already_active: 'Cette opportunité porte déjà une expérience planifiée ou en cours.',
    opportunity_not_shortlisted:
      'Une validation se prépare depuis une opportunité shortlistée ou non concluante.',
    invitation_invalid:
      'Ce lien d’invitation n’est plus valide, demandez un nouveau lien à un administrateur.',
    invitation_pending: 'Une invitation est déjà en attente pour cet email.',
    user_exists: 'Un utilisateur existe déjà avec cet email.',
    last_admin: 'Impossible : il doit rester au moins un administrateur.',
    rule_violation: 'Cette action viole une règle métier.',
    rate_limited: 'Trop de tentatives, réessayez dans un instant.',
    config_error: 'Configuration invalide, contactez un administrateur.',
    provider_error: 'Un fournisseur externe a répondu en erreur. Réessayez plus tard.',
    budget_exceeded:
      'Le budget du mois est atteint. Un administrateur peut relever le plafond dans Paramètres › Budget.',
    site_unreachable:
      'Le site n’a pas pu être lu (adresse injoignable ou erreur du serveur). Vérifiez l’URL ou saisissez les mots-clés à la main.',
    site_timeout:
      'Le site n’a pas répondu à temps. Réessayez ou saisissez les mots-clés à la main.',
    site_not_html:
      'Cette adresse ne renvoie pas une page HTML (fichier ou API). Indiquez la page d’accueil du site.',
    site_request:
      'Cette adresse n’est pas analysable (adresse interne ou schéma non http). Indiquez l’URL publique du site.',
    site_blocked:
      'Le site refuse les robots (protection anti-bot ou accès interdit). Saisissez les mots-clés à la main.',
    site_empty:
      'Le site n’expose presque pas de texte, probablement rendu en JavaScript. Saisissez les mots-clés à la main ou essayez une page de contenu.',
    internal_error: 'Erreur interne du serveur.',
    network: 'Impossible de joindre le serveur. Vérifiez votre connexion.',
    seed_in_use: 'Seed utilisé par un scan en cours.',
    label_exists: 'Un seed porte déjà ce libellé sur ce marché.',
    exclusion_exists: 'Ce terme existe déjà pour cette catégorie et ce marché.',
    self_ban: 'Vous ne pouvez pas vous bannir vous-même.',
    market: 'Marché inconnu.',
    unknown: 'Une erreur est survenue.',
    status: 'Statut',
    code: 'Code',
    requestId: 'Requête',
  },
  validation: {
    required: 'Champ requis',
    email: 'Email invalide',
    minLength: '{min} caractères minimum',
    maxLength: '{max} caractères maximum',
    nameLength: 'Entre 2 et 80 caractères',
    passwordMin: '12 caractères minimum',
    passwordMismatch: 'Les mots de passe ne correspondent pas',
    url: 'URL invalide',
    number: 'Nombre invalide',
    min: 'Valeur minimale : {min}',
    max: 'Valeur maximale : {max}',
    max20Keywords: '20 mots-clés maximum',
    keywords1to20: 'Entre 1 et 20 mots-clés',
    integer: 'Nombre entier attendu',
    positive: 'Doit être supérieur à 0',
    weightsSum: 'La somme des poids doit valoir 1,000 (± 0,001)',
    regex: 'Motif regex invalide',
    json: 'JSON invalide',
    month: 'Mois attendu au format AAAA-MM',
    date: 'Date attendue au format AAAA-MM-JJ',
    emptyPatch: 'Aucune modification à enregistrer',
    rationaleTooShort: 'Justification trop courte',
    thresholdFailBelowSuccess: 'Le seuil d’échec doit rester sous le seuil de succès',
    thresholdCpaFailAboveSuccess: 'Le seuil d’échec doit rester au-dessus du seuil de succès',
    clicksBelowImpressions: 'Les clics ne peuvent pas dépasser les impressions',
    engagedBelowVisits: 'Les visites engagées ne peuvent pas dépasser les visites',
  },
  format: {
    confidence: {
      low: 'faible',
      medium: 'moyenne',
      high: 'élevée',
    },
    trendPerMonth: '{value} / mois',
    null: '—',
  },
} as const;
